import React from 'react';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import cn from 'classnames';
import style from './viewreceipt.module.scss';

const CashPaymentCheckPopUp = (props) => {

  // Props Destructuring
  const {
    isOpen, onClose, cashPaymentCheck, auth, isPaymentTerminal, serverAppTheme
  } = props;

  const ButtonList = [
    { key: 'employeeLogin', name: `${LABEL().EMPLOYEE_LOGIN}`, visiblity: true },
    { key: 'callServer', name: `${LABEL().CALL_SERVER}`, visiblity: auth.serverAppFeatures.supportsCallServer },
    { key: 'otherOptions', name: `${LABEL().OTHER_OPTIONS}`, visiblity: true }
  ];

  // HTML CSS CODE
  return (
    <Modal
      isOpen={isOpen}
      isModalCenter
      customClass2={cn('h-100 p-3 mt-0')}
      style={{height: '100%', backgroundColor:serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, minHeight:'150px', borderRadius:'16px'}}
    >
      <div className={cn('col-12 justify-content-center align-items-center position-relative text-center px-2 py-2')} style={{color: serverAppTheme?.primary_text}} >
        <div className="px-1 text-right">
          <Cross fill={serverAppTheme?.iconcolor}
            role="presentation"
            onClick={() => { onClose(); }}
            aria-hidden="true"
          />
        </div>
        <div className='fs_32 fw-600 mt-100'>{LABEL().INFORMATION}</div>
        <div className="col-12 text-center fs_28 fw-600 px-4 h-40 d-flex align-items-center justify-content-center" style={{fontFamily: 'Poppins'}}>
          {CUSTOM_MESSAGES().CASH_PAYMENT_PROCESS}
        </div>
        <div className='col-12 position-absolute' style={{bottom: '0px', left:'0px'}}>
        <div className="col-12 text-center fs_20 fw-600" style={{fontFamily: 'Poppins'}}>
          {CUSTOM_MESSAGES().SELECT_ONE_OPTION}
        </div>
        <div className="col-12 row mx-0 p-0 py-2 justify-content-center">
          {ButtonList && ButtonList.map(({ key, name, visiblity }) => {
            return (
              <>
                {visiblity && (
                <div className="col-12 px-2 py-2">
                    <button type="submit" style={{backgroundColor: '#0060FF', borderRadius: '6px', height:'7.5vh', border:'none' }} className={cn('w-100 px-1 btn-ripple fs-30 text-center fw-600 text-white', style.divForPayment)}  onClick={() => cashPaymentCheck(key)}>
                      <div className={cn(isPaymentTerminal ? 'fs_28 fw-600' : 'fs_28 fw-600','justify-content-center')} style={{ }}>{name}</div>
                  </button>
                </div>
                )}
              </>
            );
          })}
        </div>
        </div>
      </div>
    </Modal>
  );
};

export default CashPaymentCheckPopUp;
